import { Colors } from 'common/models/theme';

const lightColors: Colors = {
  bgColor: '#ffffff',
  transparent: 'transparent', // 0
  primaryTextColor: '#666666',
  secondaryTextColor: '#666666',
  black: '#000000', // 1
  white: '#ffffff', // 2
  headingColor: '#333333',
  secondaryHeaderColor: '#333333',
  subHeadingColor: '#666666',
  headerLinkColor: '#104CA2',
  linkColor: '#016DF2',
  textColor: '#43414e', // 3
  subTextColor: '#666666',
  labelColor: '#767676', // 4
  inactiveField: '#f2f2f2', // 5
  inactiveButton: '#b7dbdd', // 6
  inactiveIcon: '#EBEBEB', // 7
  primary: '#1A7EFB', // 8
  primaryDisabled: '#CCF2E5', // 8
  primaryHover: '#2aa275', // 9
  secondary: '#edcd37', // 10
  secondaryHover: '#edcd37', // 11
  yellow: '#fdb32a', // 12
  yellowHover: '#F29E02', // 13
  // General
  primaryButtonBgColor: '#00BD7B',
  primaryButtonColor: '#ffffff',
  footerBgColor: '#CCF2E5',
  hrBgColor: '#DBDBDB',
  // borderColor: '#1b1e25', //14
  primaryBoxShadow: '0px 8px 20px -6px rgba(42, 162, 117, 0.57)',
  secondaryBoxShadow: '0px 8px 20px -6px rgba(237, 205, 55, 0.5)',
  sidebarBackgroundColor: '#EDF5FF',
  contentBgColor: '#ffffff',
  contentInnerBgColor: '#EDF5FF',
  contentInnerInnerBgColor: '#EDF5FF',
  borderColor: '#C1DCFE',
  // General Input
  inputBorder: '1px solid #DBDBDB',
  inputBorderColor: '#DBDBDB',
  inputLabelColor: '#00387C',
  inputBgColor: '#ffffff',
  inputPlaceholderColor: '#666666',
  // General Table
  tableBorderBottom: '1px solid #DBDBDB',
  // Modal
  modalBgColor: '#ffffff',
};

export default lightColors;
